import Http from './../http'

export default {
  // url: "https://momtest.feihe.com",
  // 获取我的试用列表
  getMytrialList(urlParams, params, callback) {
    Http.post(
      Http.hostName + '/xmh/lucky/trial/apply/list',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  //获取测评详情页数据
  getTestDetail(urlParams, params, callback) {
    Http.post(
      Http.hostName + '/xmh/lucky/trial/evaluation/detail',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  //标记申请理由
  markApplyResult(urlParams, params, callback) {
    Http.post(
      Http.hostName + '/xmh/lucky/trial/apply/initiate',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  //点赞
  addLike(urlParams, params, callback) {
    Http.post(
      Http.hostName + '/xmh/lucky/trial/evaluation/like',
      urlParams,
      params,
      (res) => {
        callback(res)
      }
    )
  },
  //获取试用商品详情数据
  getTrialShopDetail(urlParams, callback) {
    Http.get(
      Http.hostName + '/xmh/lucky/trial/goods/getDetailById',
      urlParams,
      (res) => {
        callback(res)
      }
    )
  },

  //获取文章收藏列表
  getInvitationList (urlParams, callback) {
    Http.get(Http.hostName + "/xmh/lucky/seeding/queryCollectContent", urlParams, (res) => {
      callback(res);
    });
  },
  // 发表测评
  getPublishEvaluation (urlParams,params, callback) {
    Http.post(Http.hostName + "/xmh/lucky/trial/evaluation/save", urlParams,params, (res) => {
      callback(res);
    });
  },
  // 上传图片
  batchPictureFile (urlParams,params, callback) {
    Http.post(Http.hostName + "/xmh/v2/upload/batchPictureFile", {ContentType:"application/x-www-form-urlencoded"},params, (res) => {
      callback(res);
    });
  }


};
